import React from 'react';
import { usePageContext } from '@/features/context/PageContext';


export default function Breadcrumb() {
      const { breadcrumb } = usePageContext();  
    const defaultBreadcrumb = breadcrumb.length > 0 ? breadcrumb : [];

    return (
        <nav aria-label="breadcrumb" className="mb-6">
          <ol className="flex items-center space-x-2">
            {defaultBreadcrumb.map((crumb, index) => (
              <li key={index} className="flex items-center">
                {crumb.url ? (
                  <a
                    href={crumb.url}
                    className="text-sm font-medium text-gray-500 hover:text-green-600 transition duration-300"
                  >
                    {crumb.label}
                  </a>
                ) : (
                  <span className="text-sm font-medium text-gray-700">{crumb.label}</span>
                )}
                {index < breadcrumb.length - 1 && (
                  <span className="mx-2 text-gray-400">/</span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      );
}
